import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Megaphone, PushPin } from "@phosphor-icons/react";

export default function CampaignUpdates({ parentType, parentId }) {
    const [updates, setUpdates] = useState([]);

    useEffect(() => {
        api.get(`/updates/public/${parentType}/${parentId}`).then(r => setUpdates(r.data));
    }, [parentType, parentId]);

    if (updates.length === 0) return null;

    return (
        <div data-testid="campaign-updates">
            <p className="label-eyebrow text-accent">Updates</p>
            <h2 className="font-heading text-3xl mt-2 mb-6">From the team</h2>
            <div className="space-y-6">
                {updates.map(u => (
                    <article key={u.id} className="ed-card p-6" data-testid={`update-${u.id}`}>
                        <div className="flex items-start gap-3 mb-3">
                            <Megaphone size={20} weight="thin" className="text-accent mt-1" />
                            <div className="flex-1">
                                <h3 className="font-heading text-2xl flex items-center gap-2">
                                    {u.pinned && <PushPin size={14} weight="fill" className="text-accent" />}
                                    {u.title}
                                </h3>
                                <p className="text-xs label-eyebrow mt-1 text-muted-foreground">
                                    {u.author_name} · {new Date(u.created_at).toLocaleDateString()}
                                </p>
                            </div>
                        </div>
                        <p className="text-foreground leading-relaxed whitespace-pre-wrap">{u.body}</p>
                    </article>
                ))}
            </div>
        </div>
    );
}
